import { prefixerM } from './common'

export const ROUTE_LPG_GESTION_CHOFERES = prefixerM('gestion-choferes')
export const ROUTE_LPG_CREAR_CHOFERES = prefixerM('crear-chofer')
export const ROUTE_LPG_GESTION_VEHICULOS = prefixerM('gestion-vehiculos')
export const ROUTE_LPG_CREAR_VEHICULOS = prefixerM('crear-vehiculo')
export const ROUTE_LPG_RUTA_VIAJE = prefixerM('ruta-viaje')
export const ROUTE_LPG_ASIGNACION_PRODUCTO_ENTIDAD = prefixerM('asignacion-producto-entidad')
export const ROUTE_LPG_GESTION_CUENTA_LOGISTICA = prefixerM('gestion-cuenta-logistica')
export const ROUTE_LPG_TIPO_LOGISTICA = prefixerM('tipo-logistica')
